export * from '@primeuix/themes/aura/select';
export { default } from '@primeuix/themes/aura/select';
